{
  "REGISTER": {
    "TRY_WOOT": "تسجيل حساب",
    "GET_STARTED": "Get started with Chatwoot",
    "TITLE": "تسجيل",
    "TESTIMONIAL_HEADER": "إن كل ما يلزم هو خطوة واحدة للمضي قدما",
    "TESTIMONIAL_CONTENT": "You're one step away from engaging your customers, retaining them and finding new ones.",
    "TERMS_ACCEPT": "من خلال التسجيل، فإنك توافق على <a href=\"https://www.chatwoot.com/terms\">شروط الخدمة</a> و <a href=\"https://www.chatwoot.com/privacy-policy\">سياسة الخصوصية</a>",
    "OAUTH": {
      "GOOGLE_SIGNUP": "Sign up with Google"
    },
    "COMPANY_NAME": {
      "LABEL": "Company name",
      "PLACEHOLDER": "Enter your company name. eg: Wayne Enterprises",
      "ERROR": "Company name is too short"
    },
    "FULL_NAME": {
      "LABEL": "الاسم الكامل",
      "PLACEHOLDER": "أدخل اسمك الكامل. مثال: بروس وين",
      "ERROR": "الاسم الكامل قصير جداً"
    },
    "EMAIL": {
      "LABEL": "البريد الإلكتروني للعمل",
      "PLACEHOLDER": "Enter your work email address. E.g., bruce{'@'}wayne{'.'}enterprises",
      "ERROR": "Please enter a valid work email address"
    },
    "PASSWORD": {
      "LABEL": "كلمة المرور",
      "PLACEHOLDER": "كلمة المرور",
      "ERROR": "كلمة المرور قصيرة جداً",
      "IS_INVALID_PASSWORD": "يجب أن تحتوي كلمة المرور على الأقل على حرف كبير واحد وحرف صغير واحد ورقم واحد وحرف خاص واحد",
      "REQUIREMENTS_LENGTH": "At least 6 characters long",
      "REQUIREMENTS_UPPERCASE": "At least one uppercase letter",
      "REQUIREMENTS_LOWERCASE": "At least one lowercase letter",
      "REQUIREMENTS_NUMBER": "At least one number",
      "REQUIREMENTS_SPECIAL": "At least one special character"
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "تأكيد كلمة المرور",
      "PLACEHOLDER": "تأكيد كلمة المرور",
      "ERROR": "كلمة المرور غير متطابقة."
    },
    "API": {
      "SUCCESS_MESSAGE": "Registration Successful",
      "ERROR_MESSAGE": "تعذر الاتصال بالخادم، الرجاء المحاولة مرة أخرى لاحقاً"
    },
    "SUBMIT": "إرسال",
    "HAVE_AN_ACCOUNT": "هل لديك حساب مسبق؟",
    "VERIFY_EMAIL": {
      "TITLE": "Check your inbox",
      "DESCRIPTION": "We sent a verification link to {email}. Click the link to verify your email and get started.",
      "RESEND": "إعادة إرسال رسالة التحقق",
      "RESEND_SUCCESS": "Verification email sent. Please check your inbox.",
      "RESEND_ERROR": "Could not send verification email. Please try again."
    }
  }
}
